import React from 'react';

import PropTypes from 'prop-types';
import qs from 'query-string';
import { withCookies } from 'react-cookie';
import {
    Redirect as RouterRedirect,
} from 'react-router';
import { renderRoutes } from 'react-router-config';

import { affiliate } from 'wanderu-service-analytics';

import type { Cookies } from 'react-cookie';
import type { RouteConfig } from 'react-router-config';

interface HandleRedirectsProps {
    location: NonNullable<RouteConfig['location']>;
    route: RouteConfig['route'];
    cookies: Cookies;
}

const arePropsEqual = (oldProps: HandleRedirectsProps, newProps: HandleRedirectsProps) => {
    return oldProps.location.pathname === newProps.location.pathname
        && oldProps.location.search === newProps.location.search
        && oldProps.route.routes === newProps.route.routes;
}; 

const HandleRedirects = (props: HandleRedirectsProps) => {
    const { location, route, cookies } = props;

    const queries = qs.parse(location?.search || '') as Record<string, string>;
    let shouldRedirect = false;

    if (queries.aid || queries.tid) {
        affiliate.setAffiliateDataCookies(cookies, {
            affiliateId: queries.aid,
            trackingId: queries.tid,
        });
        delete queries.aid;
        delete queries.tid;
        shouldRedirect = true;
    }

    const hasTrailingSlash = location.pathname.endsWith('/');
    const hasMultipleSlashes = /\/{2,}/.test(location.pathname);

    if (!hasTrailingSlash || hasMultipleSlashes) {
        shouldRedirect = true;
    }

    if (shouldRedirect) {
        const queryString = qs.stringify(queries);
        // ensure trailing slash
        let path = location.pathname + '/';
        // Remove all multiple slashes from anywhere in the path and then add back exactly one
        path = path.replace(/\/{2,}/g, '/');

        return (
            <RouterRedirect
                to={{
                    pathname: path,
                    search: queryString
                        ? `?${queryString}`
                        : '',
                }}
            />
        );
    }

    return renderRoutes(route.routes);
};

HandleRedirects.propTypes = {
    cookies: PropTypes.shape({
        get: PropTypes.func.isRequired,
        remove: PropTypes.func.isRequired,
        set: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
        search: PropTypes.string,
    }).isRequired,
    route: PropTypes.shape({
        routes: PropTypes.array,
    }).isRequired,
};

export { HandleRedirects };
export default withCookies(React.memo(HandleRedirects, arePropsEqual));
